<h4 mat-dialog-title class="text-uppercase">{{ 'auth.password_reset' | translate }}</h4>
<form mat-dialog-content [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <p>{{ 'auth.fill_information' | translate }}</p>
    <mat-form-field class="w-100" appearance="fill">
        <input matInput prefixIcon="envelope-o" placeholder="email@domain.com" type="email" formControlName="email" />
    </mat-form-field>
    <div appNbRecaptcha [key]="reCaptchaKey" formControlName="captcha"></div>

</form>
<div mat-dialog-actions class="d-flex justify-content-center">
    <button mat-raised-button class="align-self-start py-1 text-center" color="primary" [disabled]="!form.valid" (click)="submit()">
        {{ 'auth.send' | translate }}
    </button>
</div>